export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Prepaid = 'PREPAID',
  Universal = 'UNIVERSAL',
  Commercial = 'COMMERCIAL',
  Unknown = 'UNKNOWN',
}
